import { render } from "./DocProducts.vue?vue&type=template&id=34537dba&scoped=true"
import script from "./DocProducts.vue?vue&type=script&lang=js"
export * from "./DocProducts.vue?vue&type=script&lang=js"

import "./DocProducts.vue?vue&type=style&index=0&id=34537dba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34537dba"]])

export default __exports__